module.exports = __webpack_public_path__ + "static/img/MineBigRebateBg.e2ab27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SdkV3/MineBigRebateBg.png
// module id = 2sD1
// module chunks = 39